<!-- 备注信息编辑 -->
<template>
  <el-dialog
    :close-on-click-modal="false"
    :show-close="false"
    title="备注信息"
    :visible.sync="visiable"
    width="800px"
  >
    <vue-editor v-model="content" />
    <span slot="footer" class="dialog-footer">
      <el-button @click="onClickCancel">取 消</el-button>
      <el-button type="primary" @click="onClickSave">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { VueEditor } from "vue2-editor";

export default {
  name: "NotesEditerDialog",
  props: {
    visiable: {
      type: Boolean,
      default: false,
    },
    notes: {
      type: String,
      default: "",
    },
    id: {
      type: Number,
      default: 0,
    },
    onClickCancel: Function,
    onSave: Function,
  },
  components: {
    VueEditor,
  },
  watch: {
    notes: function (val) {
      this.content = val;
    },
  },
  data() {
    return {
      content: "",
    };
  },
  methods: {
    onClickSave: function () {
      this.onSave(this.id, this.content);
    },
  },
};
</script>

<style>
</style>